<template>
  <div>
    <div class="card-block__dashed container q-mb-sm draggable">
      <div v-if="loaded" class="element">
        <div class="q-pa-md full-height remainder">
          <div class="row content-block">
            <div class="flex-center">
              <!-- <q-icon name="add" /> -->
              <img
                class="block-select__icon"
                :src="require(`@/assets/icons/${getBlockIcon(block.code)}.svg`)"
              />
              <div>
                <p class="content-block__header q-ml-sm q-mr-sm">{{ getString(block.label) }}</p>
                <span
                  class="block-id q-ml-sm"
                  :class="{ 'block-id__enabled': !disabled }"
                  @click="editId"
                  ><strong>id: </strong>{{ blockId }} {{ block.id }}</span
                >
              </div>
              <transition name="fade" mode="out-in">
                <q-icon
                  v-if="error && !_isEmpty(errors)"
                  color="negative"
                  name="error_outline"
                  style="font-size: 22px"
                />
              </transition>
            </div>
            <div class="buttons">
              <q-btn
                @click="disable ? null : removeContent()"
                :disable="disable"
                align="right"
                color="negative"
                icon="close"
                size="sm"
                type="submit"
                class="q-ml-sm float-right capitalize btn-small"
              />
              <q-btn
                @click="minimized = !minimized"
                align="right"
                color="grey-4"
                text-color="grey-7"
                :icon="minimized ? 'mdi-arrow-expand' : 'mdi-arrow-collapse'"
                size="sm"
                type="submit"
                class="float-right capitalize btn-small"
              />
              <q-btn
                @click="disable ? null : duplicateBlock()"
                :disable="disable"
                align="right"
                color="grey-4"
                text-color="grey-7"
                icon="mdi-content-copy"
                size="sm"
                type="submit"
                class="q-mr-sm float-right capitalize btn-small"
              />
              <span>
                <q-icon
                  class="q-mr-sm q-pa-xs"
                  name="mdi-clock"
                  :color="publicationStatus.color"
                  size="24px"
                  :style="`cursor: ${disabled ? 'not-allowed;' : 'pointer;'}`"
                >
                  <q-tooltip>
                    <!-- Information about the publication status -->
                    <!-- No from date or to date -->
                    <template v-if="publicationStatus.visible && publicationStatus.willExpire">
                      <span>
                        {{
                          getString(
                            null,
                            `This block is visible but will no longer be visible after ${publicationStatus.willExpire}.`,
                            `This block is visible but will no longer be visible after ${publicationStatus.willExpire}.`,
                          )
                        }}
                      </span>
                    </template>
                    <template v-if="publicationStatus.visible && !publicationStatus.willExpire">
                      <span>
                        {{
                          getString(
                            null,
                            'This block is visible. Click to select dates for the visibility of this block',
                            'Dit blok is zichtbaar. Klik om data te selecteren voor de zichtbaarheid van dit blok',
                          )
                        }}
                      </span>
                    </template>
                    <template v-if="!publicationStatus.visible && !publicationStatus.willBeVisible">
                      <span>
                        {{
                          getString(
                            null,
                            'This block is not visible. The current date lies outside of the publication range.',
                            'Dit blok is niet zichtbaar. De huidige datum ligt buiten het publicatiebereik.',
                          )
                        }}
                      </span>
                    </template>
                    <template v-if="!publicationStatus.visible && publicationStatus.willBeVisible">
                      <span>
                        {{
                          getString(
                            null,
                            `This block is not visible. It will be published at ${publicationStatus.willBeVisible}`,
                            'Dit blok is niet zichtbaar. De huidige datum ligt buiten het publicatiebereik.',
                          )
                        }}
                      </span>
                    </template>
                  </q-tooltip>
                </q-icon>
              </span>
            </div>
          </div>

          <!-- Block content -->
          <div v-show="!minimized" :class="'q-mt-md'">
            <!-- Each field type -->
            <div v-for="(field, f) in block.fields" :key="f" class="q-mb-md">
              <!-- Field name (exclude publish field) -->
              <div class="q-ma-sm" v-if="field.label !== 'block.publish'">
                {{ `${getString(field.label)}${field.required === true ? ' *' : ''}` }}
              </div>

              <!-- Field -->
              <div class="row">
                <!-- Field types -->
                <div v-for="(data, d) in field.data" :key="d" class="col q-pl-sm q-pr-sm">
                  <div v-if="data.type === 'image'">
                    <div class="row flex-center">
                      <div
                        class="card-block image-preview image"
                        :class="hasErrors(f, d) && !imageSelected[f] && 'card-block__error'"
                      >
                        <div class="flex-center">
                          <img
                            class="centered"
                            v-if="imageSelected[f]"
                            :src="noCacheImage(imgSrc[f])"
                          />
                        </div>
                        <q-tooltip v-if="imageTooltip[f]" :delay="200">
                          <!-- Information about the publication status -->
                          <!-- No from date or to date -->
                          <template>
                            <span>
                              {{
                                getString(
                                  null,
                                  `File name: ${imageTooltip[f].name}`,
                                  `File name: ${imageTooltip[f].name}`,
                                )
                              }}
                            </span>
                            <br />
                            <span>
                              {{
                                getString(
                                  null,
                                  `File location: ${imageTooltip[f].folder}`,
                                  `File location: ${imageTooltip[f].folder}`,
                                )
                              }}
                            </span>
                          </template>
                        </q-tooltip>
                        <div class="image-button">
                          <q-btn
                            v-if="imageSelected[f]"
                            class="q-mr-sm capitalize"
                            :disabled="disable"
                            :color="
                              hasErrors(f, d) && !imageSelected[f]
                                ? 'negative'
                                : imageSelected[f]
                                ? 'grey-6'
                                : 'primary'
                            "
                            label="Remove"
                            @click="!disable ? removeImage(data, f) : null"
                          />
                          <q-btn
                            class="capitalize"
                            :disabled="disable"
                            :color="
                              hasErrors(f, d) && !imageSelected[f]
                                ? 'negative'
                                : imageSelected[f]
                                ? 'grey-6'
                                : 'primary'
                            "
                            :label="imageSelected[f] ? 'Edit' : 'Select'"
                            @click="!disable ? openFileSelect(f, d, 'image') : null"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="data.type === 'text'">
                    <q-field :error="hasErrors(f, d) && !data[data.name]">
                      <q-input
                        :disabled="disable"
                        :readonly="disable"
                        type="text"
                        class="full-width q-ml-md q-mr-md"
                        :float-label="getString(data.label)"
                        v-model="data[data.name]"
                        @input="updateContent()"
                      />
                    </q-field>
                  </div>

                  <div v-if="data.type === 'datetime'">
                    <q-field :error="hasErrors(f, d) && !data[data.name]">
                      <q-datetime
                        :disabled="disable"
                        :readonly="disable"
                        type="datetime"
                        format="YYYY-MM-DD HH:mm"
                        format-model="string"
                        clearable
                        class="full-width q-ml-md q-mr-md"
                        :float-label="getString(data.label)"
                        v-model="data[data.name]"
                        @input="updateContent()"
                      />
                    </q-field>
                  </div>

                  <div v-if="data.type === 'custom-autocomplete'">
                    <span class="block-information">{{
                      getString(field.value.labelInformation)
                    }}</span>
                    <!--custom-autocomplete -->
                    <q-input
                      :disabled="disable"
                      :readonly="disable"
                      clearable
                      @clear="data[field.value.name] = null"
                      type="text"
                      :error="hasErrors(f, d) && !data[field.value.name]"
                      class="full-width q-ml-md q-mr-md"
                      :float-label="getString(field.value.label)"
                      v-model="autocomplete[field.value.name]"
                      @input="updateContent()"
                    >
                      <q-autocomplete
                        value-field="value"
                        :min-characters="2"
                        @search="requestCustomAutoComplete(...arguments, data, field)"
                        @selected="selectCustomAutocomplete(...arguments, data)"
                      />
                    </q-input>
                  </div>
                  <div v-if="data.type === 'custom-autocomplete-multiple'">
                    <!--custom-autocomplete -->
                    <span class="block-information">{{
                      getString(field.value.labelInformation)
                    }}</span>
                    <chips-autocomplete
                      class="q-pb-md"
                      :disable="disable"
                      :error="hasErrors(f, d)"
                      :errorLabel="
                        $store.state.stringsStore.language === 'nl'
                          ? 'Dit veld is verplicht'
                          : 'This field is required'
                      "
                      :selection="autocompleteMultiple[field.value.name]"
                      :name="getString(field.value.label)"
                      :labelTerm="field.value.result.label"
                      :endpoint="field.value.endpoint"
                      :resultLabel="field.value.result.multipleKey"
                      @input="updateContent()"
                      @updateAutocomplete="updateAutocompleteMultiple(...arguments, data)"
                    />
                  </div>
                  <div v-if="data.type === 'autocomplete' && data.name !== 'structure'">
                    <!-- Forms -->
                    <q-input
                      :disabled="disable"
                      :readonly="disable"
                      clearable
                      @clear="data[data.name] = null"
                      type="text"
                      :error="hasErrors(f, d) && !data[data.name]"
                      class="full-width q-ml-md q-mr-md"
                      :float-label="getString(data.label)"
                      v-model="autocomplete[data.configuration.collection]"
                      @input="updateContent()"
                    >
                      <q-autocomplete
                        value-field="value"
                        :min-characters="2"
                        @search="requestAutoComplete(...arguments, data)"
                        @selected="selectAutocomplete(...arguments, data)"
                      />
                    </q-input>
                  </div>

                  <div v-if="data.type === 'autocomplete' && data.name === 'structure'">
                    <q-input
                      :disabled="disable"
                      :readonly="disable"
                      type="text"
                      :error="hasErrors(f, d) && !autocomplete[data.configuration.collection]"
                      class="full-width q-ml-md q-mr-md"
                      :float-label="getString(data.label)"
                      v-model="autocomplete[data.configuration.collection]"
                      @input="updateContent()"
                    >
                      <q-autocomplete
                        clearable
                        value-field="value"
                        :min-characters="2"
                        @search="requestAutoComplete(...arguments, data)"
                        @selected="selectStructureAutocomplete(...arguments, data, f)"
                      />
                    </q-input>
                  </div>

                  <!-- Get categories if structureId is set -->
                  <div v-if="data.type === 'categories' && structureId[d]">
                    <!-- {{ selectedCategories }} {{ c }} {{ d }} -->
                    <div v-for="(category, c) in selectedCategories[d]" :key="c" class="row">
                      <q-input
                        v-if="category !== undefined"
                        :disabled="disable"
                        :readonly="disable"
                        type="text"
                        :error="
                          (hasErrors(f, d) && !category.term) || (category.error && !category.term)
                        "
                        class="col q-ml-md q-mr-md"
                        :float-label="getString(data.label)"
                        v-model="category.term"
                        @input="updateContent()"
                      >
                        <q-autocomplete
                          clearable
                          value-field="value"
                          :min-characters="2"
                          @search="
                            requestAutoComplete(
                              ...arguments,
                              data,
                              `structure/${structureId[d]}/node/`,
                              'nodes',
                              f,
                            )
                          "
                          @selected="selectCategoryAutocomplete(...arguments, data, d, c)"
                        />
                      </q-input>
                      <q-radio
                        v-if="category !== undefined"
                        class="col col-md-1 q-mt-md"
                        :disable="!category.term"
                        @input="toggleHighlight(d, category, data)"
                        v-model="highlight[d]"
                        :val="category.id"
                      />
                    </div>
                  </div>

                  <div v-if="data.type === 'textarea'">
                    <q-input
                      :disabled="disable"
                      :readonly="disable"
                      type="text"
                      :error="hasErrors(f, d) && !data[data.name]"
                      class="full-width q-ml-md q-mr-md"
                      :float-label="getString(data.label)"
                      v-model="data[data.name]"
                      @input="updateContent()"
                    />
                  </div>

                  <!-- Specific select for button -->
                  <div v-if="data.type === 'select' && field.type === 'button'">
                    <q-select
                      :disabled="disable"
                      :readonly="disable"
                      clearable
                      :error="hasErrors(f, d) && !data[data.name]"
                      :float-label="getString(data.label)"
                      v-model="selected[data.selection]"
                      :options="buttonOptions"
                      @change="updateContent()"
                      @input="data[data.name] = selected[data.selection]"
                      class="full-width q-ml-md q-mr-md"
                    />
                  </div>

                  <div v-if="data.type === 'select' && field.type !== 'button'">
                    <q-select
                      :disabled="disable"
                      :readonly="disable"
                      clearable
                      :error="hasErrors(f, d) && !data[data.name]"
                      :float-label="getString(data.label)"
                      v-model="selected[data.selection]"
                      :options="getOptions(f, 'select')"
                      @change="updateContent()"
                      @input="data[data.name] = selected[data.selection]"
                      class="full-width q-ml-md q-mr-md"
                    />
                  </div>

                  <div v-if="data.type === 'checkbox'" class="q-pb-md">
                    <q-checkbox
                      v-for="(option, o) in getOptions(f, 'checkbox')"
                      :key="o"
                      class="q-pr-lg q-pt-md"
                      v-model="checkboxChecked[f]"
                      @input="data[data.name] = checkboxChecked[f]"
                      :label="option.label"
                      :disabled="disable"
                      :readonly="disable"
                      :val="option.value"
                    />
                    <div
                      class="q-field-bottom row no-wrap"
                      v-if="hasErrors(f, d) && !checkboxChecked[f].length"
                    >
                      <div class="q-field-error field__label field__label--warning col">
                        {{
                          $store.state.stringsStore.language === 'nl'
                            ? 'Dit veld is verplicht'
                            : 'This field is required'
                        }}
                      </div>
                    </div>
                  </div>

                  <div v-if="data.type === 'radio'">
                    <q-radio
                      v-for="(option, o) in getOptions(f, 'radio')"
                      :key="o"
                      class="q-pr-lg q-pt-md"
                      v-model="radioSelected[f]"
                      :disabled="disable"
                      :readonly="disable"
                      :error="hasErrors(f, d) && !data[data.name]"
                      @input="data[data.name] = radioSelected[f]"
                      :label="option.label"
                      :val="option.value"
                    />
                    <transition name="fade" mode="out-in">
                      <div
                        class="q-field-bottom row no-wrap"
                        v-if="hasErrors(f, d) && !radioSelected[f]"
                      >
                        <div class="q-field-error field__label field__label--warning col">
                          {{
                            $store.state.stringsStore.language === 'nl'
                              ? 'Dit veld is verplicht'
                              : 'This field is required'
                          }}
                        </div>
                      </div>
                    </transition>
                  </div>

                  <div
                    v-if="data.type === 'editor'"
                    class="editor-block"
                    :class="hasErrors(f, d) && !data[data.name] && 'editor-block__error'"
                  >
                    <editor
                      :linkList="linkedIds"
                      :disabled="disable"
                      :savedState="data[data.name]"
                      :source="{ guid, field: f, data: d }"
                    />
                  </div>

                  <div v-if="data.type === 'files'">
                    <div class="row q-mt-md" v-if="filesSelected[f].length">
                      <div class="col">{{ getString('name') }}</div>
                      <div class="col">{{ getString('size') }}</div>
                      <div class="col">{{ getString('module.library.details.file.type') }}</div>
                      <div style="width: 24px"></div>
                    </div>
                    <hr />
                    <div class="row q-pb-md" v-for="(file, s) in filesSelected[f]" :key="s">
                      <div class="col">{{ file.name }}</div>
                      <div class="col">{{ readableBytes(file.size) }}</div>
                      <div class="col">{{ `${file.type}, ${file.ext}` }}</div>
                      <q-btn
                        icon="clear"
                        :disabled="disable"
                        color="negative"
                        @click="disable ? null : removeFile(filesSelected[f], s)"
                        round
                        size="xs"
                      />
                    </div>
                    <div class="row q-mt-md">
                      <q-btn
                        @click="disable ? null : openFileSelect(f, d)"
                        color="positive"
                        :disable="disable"
                        icon="add"
                        :label="getString('editor.button.file.add')"
                        size="md"
                        type="submit"
                        class="q-mr-sm capitalize"
                      />
                    </div>
                  </div>

                  <div v-if="data.type === 'slideshow'">
                    <div class="row q-mt-md" v-if="slideshowSelected[f].length">
                      <div class="col">Images</div>
                      <div style="width: 24px"></div>
                    </div>
                    <hr />
                    <div class="row q-pb-md" v-for="(file, s) in slideshowSelected[f]" :key="s">
                      <div class="col-6">
                        <div class="slideshow__image-container">
                          <img
                            class="slideshow__image"
                            :src="buildFileLocation(`api/${file.location}`)"
                            alt=""
                          />
                        </div>
                      </div>
                      <div class="col-5">
                        <q-input
                          :float-label="getString('block.field.custom.caption')"
                          type="textarea"
                          v-model="data.items[s].caption"
                        >
                        </q-input>
                      </div>
                      <div class="col-1">
                        <q-btn
                          icon="clear"
                          :disabled="disable"
                          color="negative"
                          @click="disable ? null : removeGalleryFile(data, f, s)"
                          round
                          size="xs"
                        />
                      </div>
                    </div>
                    <div class="row q-mt-md">
                      <q-btn
                        @click="disable ? null : openFileSelect(f, d, 'image')"
                        color="positive"
                        :disable="disable"
                        icon="add"
                        :label="getString('editor.button.file.add')"
                        size="md"
                        type="submit"
                        class="q-mr-sm capitalize"
                      />
                    </div>
                  </div>

                  <div v-if="data.type === 'branches'">
                    <div v-for="(branch, b) in selectedBranches[d]" :key="b" class="row">
                      <q-input
                        v-if="branch !== undefined"
                        :disabled="disable"
                        :readonly="disable"
                        type="text"
                        :error="hasErrors(f, d) && !data[data.name]"
                        class="col q-ml-md q-mr-md"
                        :float-label="getString(data.label)"
                        v-model="branch.term"
                        @input="updateContent()"
                      >
                        <q-autocomplete
                          value-field="value"
                          :min-characters="2"
                          @search="
                            requestAutoComplete(...arguments, data, `branch/`, 'branches', f)
                          "
                          @selected="selectBranchAutocomplete(...arguments, data, d, b)"
                        />
                      </q-input>
                      <q-radio
                        v-if="branch !== undefined"
                        class="col col-md-1 q-mt-md"
                        :disable="!branch.id || !branch.term"
                        @input="toggleHighlight(d, branch, data)"
                        v-model="highlight[d]"
                        :val="branch.id"
                      />
                    </div>
                  </div>

                  <div v-if="data.type === 'uploader'">
                    <q-input
                      :disabled="disable"
                      :readonly="disable"
                      type="text"
                      class="full-width q-ml-md q-mr-md"
                      float-label="Icon name*"
                      v-model="svgIcon.codeName"
                    />
                    <q-uploader
                      class="q-mt-md"
                      :url="`${env_url}library/`"
                      method="POST"
                      :with-credentials="true"
                      :extensions="'.svg'"
                      :disable="disable"
                      @add="addSvgIcon"
                      @uploaded="uploadSvgIconSuccess"
                      @fail="uploadSvgIconFail"
                      :headers="{
                        'Content-Type': `${svgIcon.type}`,
                        'Content-Disposition': `attachment; filename=&quot;${svgIcon.name}&quot;`,
                      }"
                      :send-raw="true"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="handle">
        <div class="minimized">
          <q-icon color="grey-1" name="mdi-dots-horizontal" size="1.2rem" />
        </div>
      </div>
    </div>

    <!-- file select modal -->
    <q-modal v-if="fileModal" v-model="fileModal">
      <file-select-modal :fileType="fileTypeFilter" :guid="guid" />
    </q-modal>

    <!-- Block modal -->
    <q-modal v-model="idModal">
      <q-modal-layout>
        <q-toolbar slot="header" color="tertiary">
          <q-toolbar-title>
            Block id
          </q-toolbar-title>
          <q-btn flat round dense v-close-overlay icon="close" />
        </q-toolbar>
        <div class="q-pa-md">
          <q-input float-label="id" v-model="blockId" />

          <div class="row q-mt-lg">
            <div class="col">
              <q-btn class="q-ml-md q-mr-md q-mt-lg" color="negative" @click="updateId(true)">
                {{ getString('action.cancel') }}
              </q-btn>
            </div>
            <div class="col">
              <q-btn class="q-ml-md q-mr-md q-mt-lg" color="positive" @click="updateId()">
                {{ getString('action.save') }}
              </q-btn>
            </div>
          </div>
        </div>
      </q-modal-layout>
    </q-modal>
  </div>
</template>

<script>
/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import _isEmpty from 'lodash.isempty';
import moment from 'moment';
import qs from 'qs';

import createUuid from '@/helpers/createUuid';
import EventBus from '@/event-bus';
import getString from '@/helpers/GetStrings';
import FileSelectModal from '@/components/modal/FileSelectModal.vue';
import ChipsAutocomplete from '@/components/ChipsAutocomplete.vue';
import common from '@/mixins/library/common';
import Editor from './TinyEditor.vue';

export default {
  mixins: [common],

  props: {
    linkedIds: {
      type: Array,
      default: null,
    },
    uid: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    guid: {
      type: String,
    },
    blockType: {
      type: String,
    },
    content: {
      type: Object,
    },
    fullHeight: {
      required: false,
      default: false,
    },
  },

  components: {
    Editor,
    FileSelectModal,
    ChipsAutocomplete,
  },

  data() {
    return {
      env_url: `${process.env.VUE_APP_API_URL}`,
      errors: {},
      // Used to restrict modal select file type, eg. "image" or "file"
      fileTypeFilter: null,
      filesSelected: {},
      slideshowSelected: {},
      // Sets the field index for image select
      highlight: {},
      disable: false,
      selectedCategories: {},
      selectedBranches: {},
      autocomplete: {},
      autocompleteMultiple: {},
      structureId: {},
      imgSrc: {},
      imageIndex: {
        field: null,
        data: null,
      },
      emptyFields: true,
      imageSelected: {},
      imageTooltip: {},
      svgIcon: {
        codeName: '',
        name: '',
        type: '',
      },
      fileModal: false,
      dataSrc: null,
      minimized: true,
      types: [],
      typeData: {},
      selected: {},
      block: {
        fields: [],
      },
      // Store options for checkboxes and selects on field index
      select: [],
      checkbox: [],
      checkboxChecked: {},
      radio: [],
      radioSelected: {},
      loaded: false,
      buttonOptions: [],
      buttonSelect: null,
      prettyId: '',
      restoreId: '',
      idModal: false,
      publicationModal: false,
      publicationDates: {
        from: null,
        to: null,
      },
    };
  },
  methods: {
    getString,
    _isEmpty,

    setPublicationDates() {
      this.publicationDates = {
        from:
          this.publication && this.publication.from
            ? moment(this.publication.from).format('YYYY-MM-DD HH:mm:ss')
            : null,
        to:
          this.publication && this.publication.to
            ? moment(this.publication.to).format('YYYY-MM-DD HH:mm:ss')
            : null,
      };
    },

    savePublicationDates() {
      // Close the modal
      this.publicationModal = false;
    },

    cancelPublicationDates() {
      this.publicationModal = false;
    },

    getBlockIcon(code) {
      let icon;
      switch (code) {
        case 'default-header':
          icon = 'header-small';
          break;
        case 'default-text-plain':
          icon = 'text';
          break;
        case 'custom-youtube':
          icon = 'youtube';
          break;
        case 'custom-quote':
          icon = 'quote';
          break;
        case 'custom-text-layer':
          icon = 'text-over-image';
          break;
        case 'custom-text-image':
          icon = 'text-image';
          break;
        case 'custom-text-image-block':
          icon = 'text-image';
          break;
        case 'custom-text-image-news':
          icon = 'text-news';
          break;
        case 'custom-text-cta':
          icon = 'text-cta';
          break;
        case 'custom-assortment-category':
          icon = 'assortment-category';
          break;
        case 'custom-assortment-info':
          icon = 'assortment-info';
          break;
        case 'custom-downloads':
          icon = 'downloads';
          break;
        case 'custom-hub':
          icon = 'hub';
          break;
        case 'custom-usp':
          icon = 'usp';
          break;
        case 'custom-branches':
          icon = 'branches';
          break;
        case 'custom-header-small':
          icon = 'header-small';
          break;
        case 'custom-tiles':
          icon = 'tiles';
          break;
        case 'custom-widget':
          icon = 'widget';
          break;

        default:
          icon = 'text';
          break;
      }

      // Attempt to fetch the icon, set a fallback if it is not available.
      try {
        require(`@/assets/icons/${icon}.svg`);
      } catch (error) {
        console.warn(error);
        icon = 'text';
      }

      return icon;
    },

    duplicateBlock() {
      this.$emit('duplicate', this.block);
    },

    editId() {
      if (this.disabled) return;

      this.restoreId = this.blockId;
      this.idModal = true;
    },

    cleanId(urlString) {
      let id = urlString
        .replace(/[&|\\/\\#,+()$~%.'":*?<>{}!@^[\];±§=_`]/g, '')
        .replace('--', '-')
        .toLowerCase()
        .split(' ')
        .join('-');

      // Remove all trailing '-' characters
      while (id.charAt(id.length - 1) === '-') {
        id = id.slice(0, -1);
      }

      // Remove all leading '-' characters
      while (id.charAt(0) === '-') {
        id = id.substr(1);
      }

      return id;
    },

    updateId(cancel = false) {
      if (cancel) {
        this.blockId = this.restoreId;
      }
      this.idModal = false;
    },

    hasErrors(f, d = null) {
      if (d) {
        return this.errors[f] && this.errors[f][d];
      }
      return this.errors[f];
    },

    noCacheImage(image) {
      return image && `${image.replace('library', 'library/download')}?timestamp=${Date.now()}`;
    },

    removeFile(array, index) {
      array.splice(index, 1);
      this.updateContent();
    },

    removeImage(data, field) {
      data.content = null;
      this.imageSelected[field] = false;
    },

    removeGalleryFile(data, field, item) {
      data.items.splice(item, 1);
      this.slideshowSelected[field].splice(item, 1);
    },

    selectCustomAutocomplete(selected, keyboard, data) {
      data.id = selected.id;
    },
    selectAutocomplete(selected, keyboard, data) {
      data[data.name] = selected[data.name];
    },
    updateAutocompleteMultiple(values, data) {
      data.id = values.map(val => val.id);
    },
    // Options for selects, radios, checkboxes etc...
    getOptions(fieldIndex, name) {
      return this[name][fieldIndex].map(item => ({
        label: this.getString(item.label),
        value: item.value,
      }));
    },

    // Sets highlighted fields on structure category
    toggleHighlight(d, category, data) {
      this.highlight[d] = category.id;
      if (data.type === 'categories') {
        data[data.name] = this.selectedCategories[d].map(item => ({
          id: item.id,
          highlight: this.highlight[d] === item.id,
        }));
      }
      if (data.type === 'branches') {
        data[data.name] = this.selectedBranches[d].map(item => ({
          id: item.id,
          highlight: this.highlight[d] === item.id,
        }));
      }
    },

    // Updates the id of the selected structure
    selectStructureAutocomplete(selected, keyboard, data, fieldIndex) {
      this.structureId[fieldIndex] = selected.id;

      // sets the autocomplete id for saving content
      data[data.name] = selected.id;

      //
      if (!this.selectedCategories[fieldIndex]) {
        this.selectedCategories[fieldIndex] = [
          { id: null, highlight: false, term: '' },
          { id: null, highlight: false, term: '' },
          { id: null, highlight: false, term: '' },
          { id: null, highlight: false, term: '' },
        ];
      }
    },

    selectCategoryAutocomplete(selected, keyboard, data, fieldIndex, c) {
      // Initialize categories for the current field when undefined.
      this.selectedCategories[fieldIndex] = this.selectedCategories[fieldIndex]
        ? this.selectedCategories[fieldIndex]
        : [];

      this.selectedCategories[fieldIndex][c] = { term: selected.label, id: selected.id };
      if (this.selectedCategories[fieldIndex].length === 4) {
        data[data.name] = this.selectedCategories[fieldIndex].map(item => ({
          id: item.id,
          highlight: this.highlight[fieldIndex] === item.id,
        }));
      }
    },

    selectBranchAutocomplete(selected, keyboard, data, fieldIndex, b) {
      // Initialize categories for the current field when undefined.
      this.selectedBranches[fieldIndex] = this.selectedBranches[fieldIndex]
        ? this.selectedBranches[fieldIndex]
        : [];

      this.selectedBranches[fieldIndex][b] = { term: selected.label, id: selected.id };
      if (this.selectedBranches[fieldIndex].length === 4) {
        data[data.name] = this.selectedBranches[fieldIndex].map(item => ({
          id: item.id,
          highlight: this.highlight[fieldIndex] === item.id,
        }));
      }
    },
    requestCustomAutoComplete(terms, done, data, field) {
      const setup = field.value;
      this.axios.get(`${setup.endpoint}?autocomplete=${terms}`).then(res => {
        const results = res.data[setup.result.multipleKey];
        done(
          results.map(item => ({
            label: item[setup.result.label],
            value: item[setup.result.label],
            id: item.id || item[setup.result.value],
          })),
        );
      });
    },
    requestAutoComplete(terms, done, data, url, collection, fieldIndex) {
      if (data && data.configuration && data.configuration.url) {
        this.axios.get(`${data.configuration.url}${terms}`).then(res => {
          const results = res.data[data.configuration.collection];
          done(
            results.map(item => ({
              label: item[data.configuration.label],
              value: item[data.configuration.label],
              id: item.id,
              highlight: false,
            })),
          );
        });
      } else if (url && collection) {
        this.axios.get(`${url}?autocomplete=${terms}`).then(res => {
          let results = res.data[collection];

          // Check wich field is being requested -> filter out already selected results

          // Filter out selected branches
          if (collection === 'branches') {
            if (
              results.length &&
              this.selectedBranches[fieldIndex] &&
              this.selectedBranches[fieldIndex].length
            ) {
              results = results.filter(val => {
                const selected = this.selectedBranches[fieldIndex].map(item => item.term);
                return selected ? !selected.includes(val.name) : false;
              });
            }
            // Filter out already selected categories
          } else if (
            results.length &&
            this.selectedCategories[fieldIndex] &&
            this.selectedCategories[fieldIndex].length
          ) {
            results = results.filter(val => {
              const selected = this.selectedCategories[fieldIndex].map(item => item.term);
              return selected ? !selected.includes(val.name) : false;
            });
          }
          done(results.map(item => ({ label: item.name, value: item.name, id: item.id })));
        });
      }
    },

    openFileSelect(field, data, fileType = null) {
      // field and data index used to indicate which image field to save to
      this.imageIndex.field = field;
      this.imageIndex.data = data;

      this.fileTypeFilter = fileType;
      this.fileModal = true;
    },

    updateContent() {
      // Update the content for the editor.
      // Format fields? Updated as data in the editor.
      EventBus.$emit(`update-block:${this.guid}`, {
        fields: this.block.fields,
        id: this.blockId,
        publication: this.publicationDates,
      });
    },

    removeContent() {
      // Remove this block from the editor.
      EventBus.$emit('removeblock', this.guid);
    },

    loadField(field, fieldIndex, foundIndex, structureId) {
      return new Promise(async (resolve, reject) => {
        try {
          // Field.selection is the guid given to the select element.
          if (field.selection) {
            // Here it is reasigned to be used by the select v-model.
            this.selected[field.selection] = field.target;
          }
          switch (field.type) {
            // Apply selection
            case 'select':
              if (field.content) {
                this.$set(this.selected, field.selection, field.content);
              }
              break;

            // Process the image
            case 'image':
              this.$set(this.imgSrc, foundIndex, this.buildFileLocation(field[field.name]));
              this.$set(this.imageSelected, foundIndex, true);

              break;

            case 'files':
              this.$set(this.filesSelected, foundIndex, []);

              field[field.name].forEach(async element => {
                await this.axios.get(element).then(res => {
                  res.data.file.location = res.data.file.location.replace('api/', '');

                  this.filesSelected[foundIndex].push(res.data.file);
                });
              });

              break;

            case 'slideshow':
              this.$set(this.slideshowSelected, foundIndex, []);

              field[field.name].forEach(async element => {
                await this.axios.get(element.image).then(res => {
                  res.data.file.location = res.data.file.location.replace('api/', '');

                  this.slideshowSelected[foundIndex].push(res.data.file);
                });
              });

              break;

            // Set up autocomplete config
            case 'autocomplete':
              if (field.structure) {
                await this.axios.get(`structure/${field.structure}`).then(res => {
                  // Name to display in the structure input field
                  this.$set(
                    this.autocomplete,
                    field.configuration.collection,
                    res.data.structure.description,
                  );
                  // Id of the selected structure
                  this.$set(this.structureId, fieldIndex + 1, res.data.structure.id);
                });
              } else if (
                field.configuration &&
                ['forms'].includes(field.configuration.collection)
              ) {
                const endpoints = {
                  forms: 'form',
                };
                const endpoint = endpoints[field.configuration.collection];
                const label = field.configuration.label;
                await this.axios
                  .get(`${endpoint}/${field.id}`)
                  .then(res => {
                    // Name to display in the input field
                    const selection = (res.data[endpoint] && res.data[endpoint][label]) || '';
                    this.$set(this.autocomplete, field.configuration.collection, selection);
                  })
                  .catch(() => {
                    // Unset the field if something went wrong
                    field.id = null;
                    this.$set(this.autocomplete, field.configuration.collection, '');
                  });
              }
              break;
            case 'custom-autocomplete':
            case 'custom-autocomplete-multiple':
              // eslint-disable-next-line no-case-declarations
              const blockSetup = this.block.fields[foundIndex].value;
              // eslint-disable-next-line no-case-declarations
              const endpoint = blockSetup.endpoint;
              if (field.type === 'custom-autocomplete') {
                await this.axios
                  .get(`${endpoint}/${field.id}`)
                  .then(res => {
                    const result = res.data[blockSetup.result.key];
                    this.$set(this.autocomplete, blockSetup.name, result[blockSetup.result.label]);
                  })
                  .catch(() => {
                    // Unset the field if something went wrong
                    field.id = null;
                    this.$set(this.autocomplete, blockSetup.name, []);
                  });
              } else {
                await this.axios
                  .get(endpoint)
                  .then(res => {
                    const result = res.data[blockSetup.result.multipleKey];
                    this.$set(
                      this.autocompleteMultiple,
                      blockSetup.name,
                      result.filter(val => field.id.includes(val.id)),
                    );
                  })
                  .catch(() => {
                    // Unset the field if something went wrong
                    field.id = null;
                    this.$set(this.autocomplete, blockSetup.name, []);
                  });
              }
              break;
            case 'categories':
              this.$set(this.selectedCategories, fieldIndex, []);
              this.$set(this.highlight, fieldIndex, null);

              await field.categories.forEach((category, c) => {
                // set highlighted category id
                if (category.highlight) {
                  this.highlight[fieldIndex] = category.id;
                }

                this.axios
                  .get(`structure/${structureId || 2}/node/${category.id}`)
                  .then(res => {
                    if (res.data && res.data.node) {
                      this.$set(this.selectedCategories[fieldIndex], c, {
                        id: res.data.node.id,
                        term: res.data.node.name,
                      });
                    }
                  })
                  .catch(() => {
                    // Handle category errors
                    this.$set(this.selectedCategories[fieldIndex], c, {
                      id: null,
                      term: '',
                      error: true,
                    });
                  });
              });

              break;

            case 'branches':
              this.$set(this.selectedBranches, fieldIndex, []);
              this.$set(this.highlight, fieldIndex, null);

              await field.branches.forEach((branch, b) => {
                // set highlighted category id
                if (branch.highlight) {
                  this.highlight[fieldIndex] = branch.id;
                }

                if (branch.id) {
                  this.axios
                    .get(`branch/${branch.id}`)
                    .then(res => {
                      if (res.data && res.data.branch) {
                        this.$set(this.selectedBranches[fieldIndex], b, {
                          id: res.data.branch.id,
                          term: res.data.branch.name,
                        });
                      }
                    })
                    .catch(() => {
                      this.$set(this.selectedBranches[fieldIndex], b, {
                        id: '',
                        highlight: false,
                        term: '',
                      });
                    });
                } else {
                  this.$set(this.selectedBranches[fieldIndex], b, {
                    id: '',
                    highlight: false,
                    term: '',
                  });
                }
              });

              break;

            case 'radio':
              this.$set(this.radioSelected, foundIndex, field[field.name]);
              break;
            case 'checkbox':
              this.$set(this.checkboxChecked, foundIndex, field[field.name] || []);
              break;
            default:
          }

          resolve();
        } catch (error) {
          console.warn(error);
          reject();
        }
      });
    },

    // Filter out values (for example, tags, categories) which are no longer availible.
    filterUnusedSelection(options, field) {
      const key = field.configuration.key;
      const mappedOptions = options.map(val => val[key]);

      field[key].forEach(id => {
        if (!mappedOptions.indexOf(id)) {
          field[key] = field[key].filter(item => item === id);
        }
      });
    },

    loadBlockContent() {
      return new Promise(async resolve => {
        // filter this.block.fields based on content
        const contentFields = this.content.data || this.content;
        for (const prop in contentFields) {
          if (prop) {
            // get the property "code" from the block fields. for example "default-text-plain-title"
            const foundIndex = this.block.fields.findIndex(x => x.code === prop);

            const fields = this.block.fields[foundIndex] && this.block.fields[foundIndex].data;
            if (fields) {
              let structureId;
              // eslint-disable-next-line no-await-in-loop
              await Promise.all(
                fields
                  // eslint-disable-next-line no-loop-func
                  .map(async (field, fieldIndex) => {
                    // Assign content from this.content.data to the correct field
                    field[field.name] = contentFields[prop][field.name];
                    // Initialize special fields such as image select, checkboxes etc

                    // TODO: - Resolve on backend and remove
                    if (field.type === 'checkbox') {
                      field.content = field.content.filter(item => item !== 'press');
                    }

                    if (field.type === 'image') {
                      this.imageTooltip[foundIndex] = {
                        name: contentFields[prop].name,
                        folder: contentFields[prop].folder,
                      };
                    }

                    if (field.name === 'structure') {
                      structureId = field[field.name];
                    }

                    if (field.name === 'categories' && structureId) {
                      // Load the field with the structure id
                      await this.loadField(field, fieldIndex, foundIndex, structureId);
                    } else {
                      await this.loadField(field, fieldIndex, foundIndex);
                    }
                  }),
              );
            }
          }
        }
        resolve();
      });
    },

    populateOptions(field, index) {
      switch (field.type) {
        case 'branches':
          this.$set(this.selectedBranches, index, [
            { id: null, highlight: false, term: '' },
            { id: null, highlight: false, term: '' },
            { id: null, highlight: false, term: '' },
            { id: null, highlight: false, term: '' },
          ]);
          break;
        case 'checkbox':
          this.checkbox[index] = field.value || [];
          this.$set(this.checkboxChecked, index, []);
          break;
        case 'select':
          this.select[index] = field.value;
          break;
        case 'radio':
          this.radio[index] = field.value;
          this.$set(this.radioSelected, index, '');
          break;
        case 'files':
          this.$set(this.filesSelected, index, []);
          break;
        case 'slideshow':
          this.$set(this.slideshowSelected, index, []);
          break;
        default:
      }
    },

    fetchBlock() {
      return new Promise(async (resolve, reject) => {
        try {
          const blockType = await this.axios.get(`block/${this.blockType}`);
          this.block = blockType.data.block;
          // Map field content so that quasar inputs recieve content as strings
          let fieldCount = 0;
          this.block.fields.forEach(async (field, f) => {
            const type = await this.axios.get(`block/types/${field.type}`);

            // Fill options for radio, select, checkbox etc..
            this.populateOptions(field, f);

            // Make sure the field is reactive

            this.$set(field, 'data', type.data.type);

            fieldCount += 1;

            // Populate prefilled data
            const prefill = field.value;

            field.data.forEach(el => {
              // Check if a prefilled value has been set, otherwise initialise as an empty string
              if (el.type === 'checkbox') {
                this.$set(el, el.name, []);
              } else if (el.type === 'radio') {
                this.$set(el, el.name, null);
              } else {
                this.$set(el, el.name, prefill ? prefill[el.name] : '');
              }

              if (el.options && field.type === 'button') {
                // Need a unique v-model in case of multiple buttons.
                el.selection = createUuid();

                this.$set(this.selected, [el.selection], prefill ? prefill[el.name] : null);
                this.buttonOptions = el.options.map(option => ({
                  value: option.value,
                  label: getString(option.label),
                }));
              }
              if (field.type === 'select') {
                // Need a unique v-model in case of multiple selects.
                el.selection = createUuid();

                this.$set(this.selected, [el.selection], prefill ? prefill[el.name] : null);
              }
            });
            if (this.block && this.block.fields && this.block.fields.length === fieldCount) {
              if (this.content) {
                await this.loadBlockContent();
              }
              this.loaded = true;

              // Resolve promise when all fields have loaded
              resolve();
            }
          });
        } catch (error) {
          console.warn(error);
          reject();
        }
      });
    },

    // Takes full location as an argument and returns the nested upload folder location
    buildFileLocation(location) {
      return (
        location &&
        `${process.env.VUE_APP_API_URL}${location.replace('api/library', 'library/download')}`
      );
    },

    fileSelected(file, field) {
      file.location = file.location.replace('api/', '');

      if (field.type === 'files') {
        this.filesSelected[this.imageIndex.data].push(file);
        field.data[this.imageIndex.data].files = this.filesSelected[this.imageIndex.data].map(
          item => item.location,
        );
      } else if (field.type === 'slideshow') {
        this.slideshowSelected[this.imageIndex.data].push(file);
        field.data[this.imageIndex.data].items = this.slideshowSelected[this.imageIndex.data].map(
          (item, i) => ({
            image: item.location,
            caption: field.data[this.imageIndex.data].items[i]
              ? field.data[this.imageIndex.data].items[i].caption
              : '',
          }),
        );
      } else {
        this.imgSrc[this.imageIndex.field] = this.buildFileLocation(file.location);
        this.imageSelected[this.imageIndex.field] = true;
        const imageField = this.block.fields[this.imageIndex.field].data[this.imageIndex.data];

        imageField[imageField.name] = file.location;

        this.imageTooltip[this.imageIndex.field] = {
          location: file.location,
          name: file.name,
          folder: file.folder.location.replace('api/', ''),
        };
      }
      this.fileModal = false;
    },

    addSvgIcon(file) {
      this.svgIcon = file[0];
      this.svgIcon.codeName = this.svgIcon.name.replace('.svg', '');
    },

    async uploadSvgIconSuccess() {
      try {
        const code = await this.svgIcon.text();

        const res = await this.axios.post(
          'block/types/uploader/usp-block',
          qs.stringify({ code_name: this.svgIcon.codeName, code_svg: code }),
        );

        if (res && res.status === 201) {
          // update select field
          const response = await this.axios.put(
            'block/select',
            qs.stringify({ code_name: this.svgIcon.codeName, field_code: 'custom-usp' }),
          );

          if (response && response.status === 200) {
            this.$q.notify({
              message: this.getString(
                null,
                'File uploaded with success',
                'Bestand succesvol geüpload',
              ),
              position: 'top-right',
              timeout: 1000,
              color: 'positive',
            });

            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        }
      } catch (error) {
        // Handle promise rejection.
        console.warn(error);
      }
    },

    uploadSvgIconFail() {
      // Notify user that the upload has failed.
      this.$q.notify({
        message: getString('error.general'),
        type: 'negative',
        timeout: 2000,
        position: 'top-right',
      });
    },
  },

  computed: {
    publicationStatus: {
      get() {
        // Filter the blocks and find block with label 'block.field.publication'
        const publication = this.block.fields.find(
          field => field.label === 'block.field.publication',
        );

        let visible = true;
        let willExpire = false;
        let willBeVisible = false;
        // Get the publication dates for the block
        if (publication) {
          const from = publication.data.find(field => field.name === 'from').from;
          const to = publication.data.find(field => field.name === 'to').to;

          // Check if the current date is in the range of publication dates
          if (moment().isBefore(from) || moment().isAfter(to)) {
            visible = false;
          }

          // Check if the block will expire in the future
          if (to !== null && moment().isBefore(to)) {
            willExpire = moment(to).format('YYYY-MM-DD HH:mm:ss');
          }

          // Check if the block will be visible in the future
          if (from !== null && moment().isBefore(from)) {
            willBeVisible = moment(from).format('YYYY-MM-DD HH:mm:ss');
          }
        }

        let color = visible ? 'grey-4' : 'negative';

        if (visible && willExpire) {
          color = 'warning';
        }

        return {
          visible,
          willExpire,
          willBeVisible,
          color,
        };
      },
    },
    blockId: {
      get() {
        return this.prettyId ? this.prettyId : this.guid.split('-').pop();
      },

      set(val) {
        this.prettyId = this.cleanId(val);
      },
    },
  },

  mounted() {
    // Set the publication dates
    this.setPublicationDates();

    this.minimized = !this.fullHeight;
    this.disable = this.disabled;
    EventBus.$on(`tiny-editor:${this.guid}`, data => {
      const f = data.source.field;
      const d = data.source.data;
      const field = this.block.fields[f].data[d];
      field[field.name] = data.content;
      this.updateContent();
    });

    EventBus.$on(`file-select:${this.guid}`, data => {
      this.fileSelected(data, this.block.fields[this.imageIndex.field]);
    });

    EventBus.$on(`block-errors:${this.guid}`, data => {
      this.errors = data;
    });

    EventBus.$on('file-select-close', () => {
      this.fileModal = false;
    });

    EventBus.$on(`block-expand-collapse:${this.guid}`, minimized => {
      this.minimized = minimized;
    });

    EventBus.$on(`block-disable-enable:${this.guid}`, disable => {
      this.disable = disable;
    });

    EventBus.$on('chips-autocomplete:categories', selection => {
      this.autocompleteMultiple.categories = selection;
    });

    this.updateContent();
  },

  created() {
    this.fetchBlock()
      .then(() => {
        this.updateContent();
      })
      .catch(err => {
        console.warn(err);
      });

    // If an id is recieved, update the id
    if (this.uid) {
      this.prettyId = this.uid;
    }
  },

  updated() {
    this.updateContent();
  },

  destroyed() {
    // Clean up.
    EventBus.$off(`tiny-editor:${this.guid}`);
    EventBus.$off(`file-select:${this.guid}`);
    EventBus.$off('file-select-close');
    EventBus.$off(`block-errors:${this.guid}`);
    EventBus.$off(`block-expand-collapse:${this.guid}`);
    EventBus.$off(`block-disable-enable:${this.guid}`);
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables'
.card-block.draggable
  padding 0
.content-block
  line-height 10px
  display flex
  justify-content space-between
  &__header
    line-height 24px
    font-weight bold
    margin-bottom 0
.handle
  cursor move
  display inline-block
  vertical-align middle
  width 100%
  height 1.2rem
  border-right 2px #929AAD dashed
  border-bottom 2px #929AAD dashed
  border-left 2px #929AAD dashed
  background-color #ACACAC
  &__error
    background-color $ctrl-red-darken-2
    border-right 2px $ctrl-red-lighten-2 dashed
    border-bottom 2px $ctrl-red-lighten-2 dashed
    border-left 2px $ctrl-red-lighten-2 dashed
.buttons
  .q-btn
    padding 4px 10px
.remainder
  width 100%
.element
  display flex
  border-right 2px #ACACAC dashed
  border-top 2px #ACACAC dashed
  border-left 2px #ACACAC dashed
  &__error
    border-right 2px $ctrl-red-lighten-2 dashed
    border-top 2px $ctrl-red-lighten-2 dashed
    border-left 2px $ctrl-red-lighten-2 dashed
.minimized
  color #ccc
  display flex
  justify-content center
.image-preview {
  height: 40vh;
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
  position: relative;
  img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
.centered
  text-align center
  display: block;
  margin-left: auto;
  margin-right: auto;
.flex-center
  display flex
  justify-content center
.image-preview.image {
  height 280px
  width 450px
  background-image: linear-gradient(45deg, #F3F3F3 25%, transparent 5%), linear-gradient(-45deg, #F3F3F3 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #F3F3F3 75%), linear-gradient(-45deg, transparent 75%, #F3F3F3 75%);
}
.image-button
  float right
  margin 1em
.field__label
  &--warning
    color $ctrl-red
.editor-block
  width 100%;
.btn-small
  padding 8px !important
.block-information
.block-id
  font-size 10px
  color $ctrl-darkmatter-lighten-1
  &__enabled
    cursor pointer
.slideshow
  &__image-container
    text-align center
    border 1px solid #bdbdbd
    border-radius 2px
    margin-right 2rem
  &__image
    width 100%
    max-height 250px
    object-fit contain
    margin 0 auto
    margin-bottom -3px
</style>
